/** Room-code helpers, mirroring the server so the client can validate before sending. */

export const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const CODE_LENGTH = 4;

export function normaliseCode(input: string): string | null {
  const cleaned = input.trim().toUpperCase().replace(/\s+/g, '');
  if (cleaned.length !== CODE_LENGTH) return null;
  for (const ch of cleaned) if (!CODE_ALPHABET.includes(ch)) return null;
  return cleaned;
}

/** The link that gets shared. scope.md §7. */
export function inviteUrl(code: string, origin: string): string {
  return `${origin.replace(/\/$/, '')}/j/${code}`;
}

/** Pull a code out of an invite link path, e.g. `/j/AB2C`. */
export function codeFromPath(pathname: string): string | null {
  const match = /^\/j\/([A-Za-z0-9]{4})\/?$/.exec(pathname);
  return match ? normaliseCode(match[1]!) : null;
}
